module.exports = __webpack_public_path__ + "img/leaf-bg.122ed0a7.jpg";